import { createReducer, PayloadAction } from "@reduxjs/toolkit";

import { IProject } from "Model/Storage/IProject";
import { uiAutoCompleteSuggestionsAdd } from "Store/Actions";
import { hasNoElements } from "Utils/Array";

const SUGGESTION_BLACKLIST = [`@id`, `@status`, `costsCurrency`, `companies`];

export const AutoCompleteSuggestions = createReducer<string[]>([], {
  [uiAutoCompleteSuggestionsAdd.type]: (state, { payload }: PayloadAction<IProject[]>) => {
    if (hasNoElements(payload)) {
      return state;
    }

    const suggestions = payload.reduce((output, project) => {
      if (project == null) {
        return output;
      }

      for (const fieldName of Object.keys(project)) {
        if (SUGGESTION_BLACKLIST.includes(fieldName)) {
          continue;
        }

        output.add(fieldName);
      }

      return output;
    }, new Set(state));

    return Array.from(suggestions);
  }
});
